import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class EcsService {

  constructor( private httpService: HttpService) { }



  sampleEcsRecord(object) {
      console.log("object", object);
      // return this.http.post(environment.pssUrl + 'Investment/poaEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
      //         .map(res => res.json());
      var request = {
          URL: "ecs/ecsEntry",
          DATA: object
      }
      return this.httpService.post(request);


  }

  getRegisterDirector(object) {
      var registerList = {
          URL: "ecs/getEcsList/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(registerList);

  }

  removeEcsdetails(_id) {
      var request = {
          URL: "ecs/deleteEcsDetail/" + _id
      }
      return this.httpService.get(request);
  }

  getEcsDetail(_id) {
      var editlist = {
          URL: "ecs/getEcsDetails/" + _id,
      }
      return this.httpService.post(editlist);
  }

  updateEcsDetails(object, id) {
      var request = {
          URL: "ecs/updateEcsDetails/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  generateEcsDocument(object) {
      var request = {
          URL: "ecs/generateEcsDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadEcsFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "ecs/downloadDocument/" + id + "/" + type + "/" + token;
  }
  
  downloadEcsPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "ecs/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }


}